import "./Hizmet.css";import "./Hizmet.css";
import React from 'react'
import useDocumentTitle from "../../useDocumentTitle";
import Title from "../title/Title";

export default function EnseYanakBoyun() {
    useDocumentTitle('Kirpik Lifting- Sasha Diamond Güzellik Merkezi');
    return (
        <div className="col-12">
            <div className="card m-4" style={{align:"center",backgroundColor:"#f8f7fb",borderRadius:"5px"}}>
               <Title 
                    page_title="Kirpik Lifting"
               />
                
                <div className="card-body col-12" style={{padding:"3rem"}}>
                    <br/>
                    <h4><strong>Kirpik Lifting nedir?&nbsp;</strong></h4>
                    <p class="hizmetyazi">Kirpik Lifting içeriğinde argan yağı, proteinler, keratin ve vitaminler ile kirpikleri güçlendiren ve besleyen, hidrolize keratin bir maskedir. Besleyici maske, kirpikleri keratin ile doldurarak kirpikleri daha kalın, dolgun ve daha uzun hale getirir. Bu uygulama kirpikleri daha güçlü, daha uzun ve daha kıvrık hale getirir. Doğal kirpiğinizi x2 kat daha uzun gösterir.</p>    

                    <h4><strong>Kirpik Lifting Hakkında Merak Edilenler&nbsp;</strong></h4>
                    <p class="hizmetyazi">Kirpik lifting uygulamasını kimler tercih etmeli?
Kirpik lifting uygulamasını doğal görüntü seven ve kirpiklerinin x2-x3 kat uzun, kıvrık görünümünü yeterli bulan herkes yaptırabilir.

Genellikle uzun kirpiklerden alınan performans daha etkili olsa da kısa kirpiklerde de gözle görünür bir fark yaratmak ve aynı memnuniyeti sağlamak mümkün. 

Ense lazer epilasyonun ağrılı olmasından yakınan erkekler için Buz lazer ideal bir çözümdür. Gelişmiş soğutma sistemi ve patentli uygulama tekniği ile ağrısız bir lazer epilasyon sunan Buz Lazer, erkekler tarafından en çok ilgi gören lazer epilasyon yöntemidir. Yaklaşık 3 dakika gibi kısa bir sürede Buz Lazer ile ense kıllarından ağrısız, acısız ve yan etki riski olmadan kurtulmak mümkün. 

Yaz aylarında da uygulanabilen  Buz Lazer günümüzün en gelişmiş lazer epilasyon yöntemidir. FDA onayına sahip Buz Lazer etkili ve kalıcı sonuçlara sahiptir.</p> 

                    <h4><strong>Kirpik lifting nasıl uygulanır?&nbsp;</strong></h4>
                    <p class="hizmetyazi">İlk aşamasında kirpikler temizlenip yağdan arındırılır
<br/>
İkinci aşamasında kişinin kirpiklerine uygun kalıplara kirpikler yerleştirilip aynı zamanda istediği şekil verilerek uzatılır
<br/>
Üçüncü aşamasında kirpiklere keratin desteği verilir
<br/>
Dördüncü aşamasında pigmentlerle rimel görüntüsü verilir
<br/>
Beşinci aşamada ise kirpikler vitamin ile beslenir.</p> 
<br/>
                    <h4><strong>Neden kirpik lifting uygulaması yaptırmalısınız?&nbsp;</strong></h4>
                    <p class="hizmetyazi">Kirpik lifting ile makyaj yapmadan, sudan denizden etkilenmeden sürekli rimelli görünümde kirpiklere sahip olmanız ve sürekli bakımlı gözükmek için lifting uygulaması yaptırmalısınız.

Aynı zaman da Kirpik lifting seti yardımıyla yapılan uygulamasının 3 uygulama sonrasında kirpikleri uzattığı da görülmüştür.</p> 

                    <h4><strong>Kirpik perması ile kirpik lifting arasındaki fark nedir?&nbsp;</strong></h4>
                    <p class="hizmetyazi">Perma içerisinde çok fazla kimyasal barındırır ve bu sebeple kirpiklerde yanma, kopma gibi deformasyonlara neden olabilir.
Lifting içerisinde bulunan keratin ve vitaminler sayesinde kirpiklere herhangi bir zarar gelmeyeceği gibi düzenli ve devamlı kullanımda kirpiklerde bakım etkisini gösterir. </p> 


                </div>
            </div>
            
        </div>
    )
}



